/* eslint-disable no-unused-vars */
import RegionService from '_services/rest/modules/region';

export default {
  state: {
    region: null,
    regionList: null,
    detachedDistributors: null,
    attachedDistributors: null,
    allAttachedDistributors: null,
  },
  mutations: {
    setRegionList(state, response) {
      state.regionList = response;
    },
    setRegion(state, response) {
      state.region = response;
    },
    setDetachedDistributors(state, response) {
      state.detachedDistributors = response;
    },
    setAttachedDistributors(state, response) {
      state.attachedDistributors = response;
    },
    setAllAttachedDistributors(state, response) {
      state.allAttachedDistributors = response;
    },
  },
  actions: {
    getRegionList({ commit }, params) {
      return RegionService.getList(params).then(response => {
        commit('setRegionList', response);
      });
    },
    getRegion({ commit }, params) {
      return RegionService.getRegionById(params)
        .then(region => {
          commit('setRegion', region);
          return region;
        })
        .catch(error => {
          throw error.message;
        });
    },

    saveRegion({ commit }, params) {
      return RegionService.save(params);
    },

    deleteRegion({ commit }, params) {
      return RegionService.delete(params);
    },

    getRegionDistributors({ commit }, params) {
      if (!params.search && params.group === 'attached') {
        return RegionService.getRegionDistributors({
          ...params,
          take: 0,
        }).then(response => {
          if (params.page === 1) commit('setAllAttachedDistributors', response);
          commit('setAttachedDistributors', response);
          return response;
        });
      }

      return RegionService.getRegionDistributors(params).then(response => {
        if (params.group && params.group === 'attached') {
          if (!params.search) {
            commit('setAllAttachedDistributors', response);
          }
          commit('setAttachedDistributors', response);
          return response;
        }
        commit('setDetachedDistributors', response);
        return response;
      });
    },

    syncAttacherDistributors({ commit }, { attachedDistributor, id }) {
      const resellers = attachedDistributor.map(reseller => ({
        id: reseller.id,
      }));
      commit('setAllAttachedDistributors', {
        total_items: attachedDistributor.length,
        pages: Math.ceil(attachedDistributor.length / 10),
        list: attachedDistributor
      });
      return RegionService.syncResellers({
        id,
        resellers,
      });
    },

    clearRegionList({ commit }) {
      commit('setRegionList', null);
    }
  },
};
